import mutations from "./mutations";
import actions from "./actions";

const state = {
  pageData: {
    current: 1,
    size: 20,
    pageTotal: 0,
    currentPage: 1
  },
  searchData: {
    current: 1,
    size: 20,
    companyId: ""
  },
  treeLoading: false,
  treeData: [],
  tableData: [],
  tableLoading: false
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
